(function(){
  function init(root){
    if(root.dataset.mBnrReady) return;
    root.dataset.mBnrReady = '1';
    var track = root.querySelector('.m-bnr__track');
    if(!track) return;
    track.style.scrollBehavior = 'auto';
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('.m-bnr__dot'));
    var prev = root.querySelector('.m-bnr__nav--p');
    var next = root.querySelector('.m-bnr__nav--n');
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    var i = 0, timer = null, paused = false, anim = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n){
      i = (n + slides.length) % slides.length;
      var to = slides[i].offsetLeft, from = track.scrollLeft, d = to - from;
      if(anim) cancelAnimationFrame(anim);
      if(reduce || Math.abs(d) < 2){ track.scrollLeft = to; mark(); return; }
      var t0 = null, dur = 420;
      function step(ts){
        if(t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = from + d * e;
        if(p < 1) anim = requestAnimationFrame(step); else anim = null;
      }
      anim = requestAnimationFrame(step);
      mark();
    }
    function mark(){
      dots.forEach(function(dt, n){ dt.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      slides.forEach(function(sl, n){
        var v = sl.querySelector('video');
        if(!v) return;
        if(n === i){ var pl = v.play(); if(pl && pl.catch) pl.catch(function(){}); }
        else { v.pause(); }
      });
    }
    function tick(){ if(!paused) go(i + 1); }
    function start(){ if(delay > 0 && slides.length > 1 && !timer) timer = setInterval(tick, delay); }

    if(prev) prev.addEventListener('click', function(){ go(i - 1); });
    if(next) next.addEventListener('click', function(){ go(i + 1); });
    dots.forEach(function(dt, n){ dt.addEventListener('click', function(){ go(n); }); });

    var st;
    track.addEventListener('scroll', function(){
      if(anim) return;
      clearTimeout(st);
      st = setTimeout(function(){
        var n = Math.round(track.scrollLeft / track.clientWidth);
        if(n !== i){ i = Math.min(Math.max(n, 0), slides.length - 1); mark(); }
      }, 90);
    }, { passive: true });

    root.addEventListener('pointerenter', function(){ paused = true; });
    root.addEventListener('pointerleave', function(){ paused = false; });
    root.addEventListener('focusin', function(){ paused = true; });
    document.addEventListener('visibilitychange', function(){ paused = document.hidden; });

    var mute = root.querySelector('.m-bnr__mute');
    if(mute){
      mute.addEventListener('click', function(){
        var on = mute.getAttribute('data-muted') === '1';
        root.querySelectorAll('video').forEach(function(v){ v.muted = !on; });
        mute.setAttribute('data-muted', on ? '0' : '1');
        mute.textContent = on ? (mute.dataset.on || 'Sound on') : (mute.dataset.off || 'Sound off');
      });
    }
    mark();
    start();
  }
  function boot(){ document.querySelectorAll('.m-bnr').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
